const __WEBPACK_NAMESPACE_OBJECT__ = require("@projectstorm/react-canvas-core");